/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './obstetric-event.reducer';

export const ObstetricEvent = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const obstetricEventList = useAppSelector(state => state.obstetricEvent.entities);
  const loading = useAppSelector(state => state.obstetricEvent.loading);
  const totalItems = useAppSelector(state => state.obstetricEvent.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="obstetric-event-heading" data-cy="ObstetricEventHeading">
        <Translate contentKey="tinyMedicRestApp.obstetricEvent.home.title">Obstetric Events</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.obstetricEvent.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/obstetric-event/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.obstetricEvent.home.createLabel">Create new Obstetric Event</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.obstetricEvent.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {obstetricEventList && obstetricEventList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('pregnancyConfirmedDate')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.pregnancyConfirmedDate">Pregnancy Confirmed Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pregnancyConfirmedDate')} />
                </th>
                <th className="hand" onClick={sort('lengthOfPregnancy')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.lengthOfPregnancy">Length Of Pregnancy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lengthOfPregnancy')} />
                </th>
                <th className="hand" onClick={sort('dandc')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.dandc">Dandc</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dandc')} />
                </th>
                <th className="hand" onClick={sort('childGender')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.childGender">Child Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('childGender')} />
                </th>
                <th className="hand" onClick={sort('childWeight')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.childWeight">Child Weight</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('childWeight')} />
                </th>
                <th className="hand" onClick={sort('complications')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.complications">Complications</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('complications')} />
                </th>
                <th className="hand" onClick={sort('deliveryType')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.deliveryType">Delivery Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deliveryType')} />
                </th>
                <th className="hand" onClick={sort('eventType')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.eventType">Event Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventType')} />
                </th>
                <th className="hand" onClick={sort('labourStartDate')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.labourStartDate">Labour Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('labourStartDate')} />
                </th>
                <th className="hand" onClick={sort('lenghtOfLabor')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.lenghtOfLabor">Lenght Of Labor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lenghtOfLabor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('expose')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.expose">Expose</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expose')} />
                </th>
                <th className="hand" onClick={sort('consentTaken')}>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.consentTaken">Consent Taken</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consentTaken')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.obstetricEvent.pregnancy">Pregnancy</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {obstetricEventList.map((obstetricEvent, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/obstetric-event/${obstetricEvent.id}`} color="link" size="sm">
                      {obstetricEvent.id}
                    </Button>
                  </td>
                  <td>{obstetricEvent.pregnancyConfirmedDate}</td>
                  <td>{obstetricEvent.lengthOfPregnancy}</td>
                  <td>{obstetricEvent.dandc}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Gender.${obstetricEvent.childGender}`} />
                  </td>
                  <td>{obstetricEvent.childWeight}</td>
                  <td>{obstetricEvent.complications}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.DeliveryType.${obstetricEvent.deliveryType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PregnancyResult.${obstetricEvent.eventType}`} />
                  </td>
                  <td>{obstetricEvent.labourStartDate}</td>
                  <td>{obstetricEvent.lenghtOfLabor}</td>
                  <td>{obstetricEvent.active ? 'true' : 'false'}</td>
                  <td>{obstetricEvent.draft ? 'true' : 'false'}</td>
                  <td>{obstetricEvent.cursor}</td>
                  <td>{obstetricEvent.lastUpdated}</td>
                  <td>{obstetricEvent.microSec}</td>
                  <td>{obstetricEvent.timestampEntry}</td>
                  <td>{obstetricEvent.expose ? 'true' : 'false'}</td>
                  <td>{obstetricEvent.consentTaken ? 'true' : 'false'}</td>
                  <td>
                    {obstetricEvent.patient ? <Link to={`/gluco-user/${obstetricEvent.patient.id}`}>{obstetricEvent.patient.id}</Link> : ''}
                  </td>
                  <td>
                    {obstetricEvent.pregnancy ? (
                      <Link to={`/pregnancy-case/${obstetricEvent.pregnancy.id}`}>{obstetricEvent.pregnancy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/obstetric-event/${obstetricEvent.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/obstetric-event/${obstetricEvent.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/obstetric-event/${obstetricEvent.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.obstetricEvent.home.notFound">No Obstetric Events found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={obstetricEventList && obstetricEventList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ObstetricEvent;
